import { Global, css } from '@emotion/react';
import Routes from '@/routes';
import { getColor, GrainProvider, vars } from '@flodesk/grain';

const globalStyles = css`
  @font-face {
    font-family: 'Flodesk Sans';
    font-weight: 400;
    src:
      url('/fonts/FlodeskSans/FlodeskSans-Regular.woff2') format('woff2'),
      url('/fonts/FlodeskSans/FlodeskSans-Regular.woff') format('woff');
  }
  @font-face {
    font-family: 'Flodesk Sans';
    font-weight: 500;
    src:
      url('/fonts/FlodeskSans/FlodeskSans-Medium.woff2') format('woff2'),
      url('/fonts/FlodeskSans/FlodeskSans-Medium.woff') format('woff');
  }
  @font-face {
    font-family: 'FlotesqueGX';
    font-weight: 400;
    src: url('/fonts/FlotesqueGX/FlotesqueGX_v2.ttf') format('truetype');
  }
  *,
  *::before,
  *::after {
    box-sizing: border-box;
  }
  body {
    margin: 0;
    font-family: 'Flodesk Sans', sans-serif;
    font-size: 14px;
    color: ${getColor(vars.colors.content)};
    background-color: ${getColor(vars.colors.shade1)};
  }
  @keyframes float1 {
    0%,
    100% {
      transform: translateY(0px) rotate(-2.47deg);
    }
    50% {
      transform: translateY(-12px) rotate(-2.47deg);
    }
  }
  @keyframes float2 {
    0%,
    100% {
      transform: translateY(0px) rotate(1.76deg);
    }
    50% {
      transform: translateY(-16px) rotate(1.76deg);
    }
  }
  @keyframes float3 {
    0%,
    100% {
      transform: translateY(0px) rotate(5.55deg);
    }
    50% {
      transform: translateY(-10px) rotate(5.55deg);
    }
  }
`;

export default function App() {
  return (
    <GrainProvider>
      <Global styles={globalStyles} />
      <Routes />
    </GrainProvider>
  );
}
